// extracted by mini-css-extract-plugin
module.exports = {"root":"TabGroupsSelector_root__O2FPK","tabLabel":"TabGroupsSelector_tabLabel__7_bbm","tab":"TabGroupsSelector_tab__so5z6","active":"TabGroupsSelector_active__BthDj"};